import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { cart } from '@/theme/Cart';
import { QuantitySelector } from '../QuantitySelector/QuantitySelector';
import { html, render } from 'lit-html';

declare global {
    interface Window {

        // eslint-disable-next-line @typescript-eslint/naming-convention
        AddToSmartWishlist?: {
            (productId: number, variantId: number): string;
        };
    }
}

interface VariantContent {
    id: number;
    variantSize: string;
}

@Component
export class CartItemRow extends ThemeComponent {
    @Prop item!: Shopify.Liquid.LineItem;

    @Ref({ required: false }) quantitySelector!: QuantitySelector;
    @Ref({ required: false }) removeItemButton!: HTMLButtonElement[];
    @Ref({ required: false }) actionsDrawer!: HTMLElement;
    @Ref({ required: false }) closeActionsDrawerButton!: HTMLButtonElement;
    @Ref({ required: false }) selectedMetafieldSize?: HTMLElement;
    @Prop variantContent!: VariantContent[];

    init() {

        // Listen for item remove clicks
        for (const button of this.removeItemButton) {
            this.$listen(button, 'click', () => this.handleQuantity(0));
        }

        // Subscribe to quantity change
        if (this.quantitySelector) {
            this.$subscribe(this.quantitySelector.onChange, (quantity) => {
                this.handleQuantity(quantity).catch((e) => {
                    this.$log.error(`Update quantity failed`, { e });
                });
            });
        }

        // Listen for outer actions drawer click
        this.listenForOuterActionsDrawerClick();

        // Listen for close actions drawer button click
        this.listenForCloseActionsDrawerButtonClick();

        // Update the custom value from metafield
        this.updateMetafieldData();

    }

    async handleQuantity(quantity: number) {

        // Find matching cart item
        let matchingItem = null;
        for (const item of cart.items) {
            if (item.key === this.item.key) {
                matchingItem = item;
            }
        }
        if (matchingItem === null) {
            this.$log.error(`No matching item found`);
            return;
        }

        // Attemp quantity update
        try {
            if (quantity === 0) {

                // Remove item
                await cart.removeItem(matchingItem);
            } else {

                // Change item
                await cart.changeItem(matchingItem, quantity, null);
            }
        } catch (event: unknown) {
            const { message } = event as Error;
            this.$log.error('Cart item quantity update error', message);
        }

        // Dispatch event for other components to listen to
        document.dispatchEvent(new Event('cartChanged'));
    }

    listenForOuterActionsDrawerClick() {
        if (!this.actionsDrawer) {
            return;
        }
        this.$listen(this, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement === this.actionsDrawer) {
                    this.actionsDrawer.classList.remove('cart-item-row__actions-drawer--active');
                }
            }
        });
    }

    listenForCloseActionsDrawerButtonClick() {
        if (!this.actionsDrawer) {
            return;
        }
        if (!this.closeActionsDrawerButton) {
            return;
        }
        this.$listen(this.closeActionsDrawerButton, 'click', () => {
            this.actionsDrawer.classList.remove('cart-item-row__actions-drawer--active');
        });
    }

    updateMetafieldData() {
        const itemId = this.item.id;

        const stickyMatchedContent = this.variantContent.find(
            (v) => v.id === itemId
        );

        if (
            stickyMatchedContent &&
            stickyMatchedContent.variantSize &&
            this.selectedMetafieldSize
        ) {
            render(html`
                ${stickyMatchedContent.variantSize}
            `, this.selectedMetafieldSize);
        }
    }


}
